// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import './Section.css';

export interface SectionProps extends React.HTMLAttributes<HTMLDivElement> {
  raised?: boolean;
  padded?: boolean;
  loading?: boolean;
  children: React.ReactNode;
}

export function Section({
  raised = false,
  padded = false,
  loading = false,
  children,
  className = '',
  ...rest
}: SectionProps) {
  const classes = [
    'fin-section',
    raised && 'fin-section--raised',
    padded && 'fin-section--padded',
    loading && 'fin-section--loading',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
